import { EXTRACT_TENANTID_FROM_URL } from '@ibinder/common-utils';

//this is <script src"d> in main index.html, special module, doesn"t import normally
declare const devSettings: any;
declare const instanceSettings: any;

const appSettings = location.host.includes('localhost')
  ? devSettings
  : instanceSettings;

const getAppConfig = (setting) => (key) => setting[key];

export const getAppSetting = (key) => {
  const result = getAppConfig(appSettings)(key);

  if (result.toString().includes('#{')) {
    throw Error(`The Key (${key}) has not been transformed`);
  }
  return result;
};
